module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"energyUsage":"Energienutzung","energyCarrier":"Energieträger","ownUse":"Verwendung","scenario":"Szenario:"}}')
  delete Component.options._Ctor
}
